import {
  AdminInput,
  Button,
  Div,
  Label,
  TrashIconRed,
} from '@vgrubs/components';
import styled from 'styled-components';
import { BlogHighlight } from '../../types/blog.types';
import { MAX_BLOG_HIGHLIGHTS } from './data';

// The row's trash can, a real button so the keyboard reaches it.
const RemoveButton = styled.button`
  display: flex;
  flex: none;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
`;

type Props = {
  client: string | null;
  highlights: BlogHighlight[] | null;
  onClient: (client: string) => void;
  onHighlights: (highlights: BlogHighlight[]) => void;
};

/**
 * What a case study's card on vgrubs.com/case-studies shows besides its
 * picture and title: who the restaurant is, and up to three numbers, each
 * with what it counts.
 */
export const BlogCaseStudyFields = ({
  client,
  highlights,
  onClient,
  onHighlights,
}: Props) => {
  const rows = highlights ?? [];

  const edit = (index: number, change: Partial<BlogHighlight>) =>
    onHighlights(
      rows.map((row, i) => (i === index ? { ...row, ...change } : row))
    );

  return (
    <>
      <AdminInput
        label="Client"
        type="text"
        placeholder="Bagel franchise, 15 locations in New York and New Jersey"
        value={client ?? ''}
        onChange={({ target }) => onClient(target.value)}
      />

      <div>
        <Label
          label="Highlights"
          tooltip="Up to three numbers on the case study's card, each with what it counts."
        />
        <Div $flex $column $gap="12px">
          {rows.map((row, i) => (
            // Rows have no id of their own: they are only ever added at the
            // end and removed by position.
            <Div key={i} $flex $alignCenter $gap="8px">
              <Div $flexNone $width="180px" $widthSM="110px">
                <AdminInput
                  aria-label={`Highlight ${i + 1} value`}
                  placeholder="$4,526"
                  value={row.value}
                  onChange={({ target }) => edit(i, { value: target.value })}
                />
              </Div>
              <AdminInput
                aria-label={`Highlight ${i + 1} label`}
                placeholder="extra revenue a month at one location"
                value={row.label}
                onChange={({ target }) => edit(i, { label: target.value })}
              />
              <RemoveButton
                type="button"
                aria-label={`Remove highlight ${i + 1}`}
                onClick={() => onHighlights(rows.filter((_, j) => j !== i))}
              >
                <TrashIconRed />
              </RemoveButton>
            </Div>
          ))}
          {rows.length < MAX_BLOG_HIGHLIGHTS && (
            <Div>
              <Button
                type="button"
                $gray
                $small
                onClick={() =>
                  onHighlights([...rows, { value: '', label: '' }])
                }
              >
                Add Highlight
              </Button>
            </Div>
          )}
        </Div>
      </div>
    </>
  );
};
